var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCultwineLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0908 0.357642C8.41224 1.5935 0.5 9.19469 0.5 19.998C0.5 30.8013 8.41224 38.3997 18.0908 39.6411C27.0167 40.7853 32.4545 38.9357 35.4038 37.5499V22.5391H33.4237V22.5364C25.0199 22.5364 18.2352 28.3213 18.2352 37.7249C16.8299 37.4832 15.7718 37.2999 14.3221 36.6834C14.3916 36.1002 14.4054 28.1824 14.4027 19.998C14.4054 11.8136 14.3916 3.89579 14.3221 3.31258C15.7718 2.69604 16.8299 2.51275 18.2352 2.27113C18.2352 11.6747 25.0199 17.4596 33.4237 17.4596H35.4066V2.4461C32.4545 1.06027 27.0195 -0.786564 18.0908 0.357642Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCultwineLogo);
export default __webpack_public_path__ + "static/media/cultwine-logo.a3c711b7b6e7a11846c1b7a366c779a2.svg";
export { ForwardRef as ReactComponent };